import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { RiSearch2Line } from "react-icons/ri";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { CreateModuleModal } from "../../../components/admin/programs/CreateModuleModal";
import { DeleteProgramModuleModal } from "../../../components/admin/programs/DeleteModuleModal";
import { EditModuleModal } from "../../../components/admin/programs/EditModuleModal";
import Loading from "../../../components/common/Loading";
import delete_vector from "../../../img/deleteVectorRed.svg";
import { IProgramModule } from "../../../models/admin/programs/module.model";
import program_moduleService from "../../../services/program_service/program_module.service";

const AdminProgramModules = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [courseToModule, setCourseToModule] = useState(false);
  const [loading, setLoading] = useState(true);
  const [advertise, setAdvertise] = useState(false);
  const [assigncourse, setAssignCourse] = useState(false);
  const [deletecourse, setDeleteCourse] = useState(false);
  const [reload, setReload] = useState(false);
  const [isModule, setisModule] = useState(false);
  const [isEditModule, setisEditModule] = useState(false);
  const [moduleId, setmoduleId] = useState("");
  const [selectedModule, setSelectedModule] = useState<IProgramModule>();
  const [programModules, setprogramModules] = useState<IProgramModule[]>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [fileteredprogramModules, setFilteredprogramModules] = useState<
    IProgramModule[]
  >([]);

  useEffect(() => {
    program_moduleService.getModules().then((res) => {
      setprogramModules(res.data);
      setFilteredprogramModules(res.data);
      setLoading(false);
    });
  }, [reload]);

  const openDeleteModuleModal = async (id: string) => {
    setCourseToModule(false);
    setAssignCourse(false);
    setAdvertise(false);
    setisModule(false);
    setmoduleId(id);
    setDeleteCourse(true);
    setisEditModule(false);
    onOpen();
  };
  const openEditoduleModal = async (module: IProgramModule) => {
    setCourseToModule(false);
    setAssignCourse(false);
    setAdvertise(false);
    setisModule(false);
    setSelectedModule(module);

    setDeleteCourse(false);
    setisEditModule(true);
    onOpen();
  };

  const openCreateModuleModal = async () => {
    setCourseToModule(false);
    setAssignCourse(false);
    setAdvertise(false);
    setDeleteCourse(false);
    setisModule(true);
    setisEditModule(false);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
    setSelectedModule(undefined);
    setmoduleId("");
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredprogramModules(programModules);
    } else {
      if (programModules) {
        const filtered = programModules.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredprogramModules(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Flex
            minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}
          >
            <Box
              width={["4rem", "4rem", "4rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>

            <Box width={"100%"}>
              <AdminDashboardHeader />
              <Box
                pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  py="26px"
                >
                  <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                    Program Modules
                  </Box>
                  <HStack>
                    <Button
                      py="7px"
                      px="10px"
                      onClick={() => {
                        openCreateModuleModal();
                      }}
                      fontSize={13}
                      borderRadius={2}
                      colorScheme="red"
                      height="32px"
                    >
                      Add module
                    </Button>
                  </HStack>
                </Flex>
                <Flex py="15px" justifyContent="">
                  <InputGroup
                    color="brand.subtitle"
                    bg="white"
                    width={["100%", "100%", "50%", "30%"]}
                    mr="20px"
                  >
                    <Input
                      height="40px"
                      placeholder="Search for modules"
                      onChange={(e) => handleSearchChange(e)}
                      fontSize={12}
                      size="sm"
                    />
                    <InputRightElement
                      pointerEvents="none"
                      children={<RiSearch2Line color="red" size="0.9rem" />}
                    />
                  </InputGroup>
                </Flex>
                <Box width="100%">
                  <TableContainer>
                    <Table variant="simple">
                      <Thead mb="10px">
                        <Tr
                          pb="10px"
                          borderBottom="1px solid"
                          borderColor="#D5D5D5"
                        >
                          <Th textTransform="none">Modules</Th>
                          <Th textTransform="none">Module Code</Th>
                          <Th textTransform="none">Options</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {fileteredprogramModules.map((each, index) => (
                          <Tr key={index} bg="white">
                            <Td>
                              <HStack spacing="10px">
                                <Text
                                  fontWeight="600"
                                  textTransform="capitalize"
                                  fontSize="16px"
                                  color="#616161"
                                >
                                  {each.name}
                                </Text>
                              </HStack>
                            </Td>

                            <Td>{each.code}</Td>

                            <Td>
                              <HStack>
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  onClick={() => {
                                    openEditoduleModal(each);
                                  }}
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                >
                                  <HiOutlinePencil />
                                </Center>
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  onClick={() => {
                                    openDeleteModuleModal(each.uuid.toString());
                                  }}
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                >
                                  <Image
                                    src={delete_vector}
                                    width="18px"
                                    height="18px"
                                  />
                                </Center>
                              </HStack>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Flex>

          {deletecourse && (
            <Portal>
              {" "}
              <DeleteProgramModuleModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                moduleId={moduleId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {isModule && (
            <Portal>
              {" "}
              <CreateModuleModal
                isOpenModule={isOpen}
                onClosed={onClose}
                isModule={isModule}
                reload={reloadData}
              />{" "}
            </Portal>
          )}
          {isEditModule && (
            <Portal>
              {" "}
              <EditModuleModal
                isOpenEditModule={isOpen}
                onClosed={onClose}
                isEditModule={isEditModule}
                modulename={selectedModule?.name}
                modulecode={selectedModule?.code}
                moduleDesc={selectedModule?.description}
                module_id={selectedModule?.uuid}
                reload={reloadData}
              />{" "}
            </Portal>
          )}
        </Box>
      )}
    </>
  );
};

export default AdminProgramModules;
